import {Component, Input, OnInit, QueryList, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {BsDatepickerConfig, BsDatepickerDirective, BsLocaleService} from 'ngx-bootstrap/datepicker';
import {CampoDataService} from 'src/app/api/module/erp/shared/services/campoData/campo-data.service';
import {ErrorLoggingService} from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';

@Component({
  selector: 'app-campo-data',
  templateUrl: './campo-data.component.html',
  styleUrls: ['./campo-data.component.scss'],
})
export class CampoDataComponent implements OnInit {
  @ViewChild('datepicker', {static: false}) datepicker?: BsDatepickerDirective;

  @Input() minDate!: Date;
  @Input() maxDate!: Date;
  @Input() nomeCampo!: string;
  @Input() controlName!: string;
  @Input() ehVisualizar: boolean = false;
  @Input() control!: FormControl;
  @Input() isFormSubmited: boolean = false;
  @Input() formGroup!: any;
  @Input() modoMesAno: boolean = false;
  @Input() placeholder?: string;

  bsConfig: Partial<BsDatepickerConfig>;
  inputDataSelecionado: boolean = false;
  datepickersArray!: QueryList<BsDatepickerDirective>;

  constructor(
    private _campoDataService: CampoDataService,
    private _bsLocaleService: BsLocaleService,
    private errorLogging: ErrorLoggingService,
  ) {
    this._bsLocaleService.use('pt-br');
    this.bsConfig = {
      isAnimated: true,
      dateInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      adaptivePosition: true,
    };
  }

  ngOnInit(): void {
    if (this.modoMesAno) {
      this.bsConfig = {
        ...this.bsConfig,
        minMode: 'month',
        dateInputFormat: 'MM/YYYY',
      };
    }
  }

  campoDataSelecionado(event: FocusEvent, index?: number) {
    this.inputDataSelecionado = true;
    if (index !== undefined && index !== null) {
      this._campoDataService.campoDataSelecionado(event, undefined, this.datepickersArray, index);
    } else {
      this._campoDataService.campoDataSelecionado(event, this.datepicker, undefined, index);
    }
  }

  esconderCalendario(index?: number) {
    if (index !== null && index !== undefined) {
      if (this.inputDataSelecionado === true) {
        this._campoDataService.esconderCalendario(undefined, this.datepickersArray, index);
      }
      return;
    }
    if (this.inputDataSelecionado === true) {
      this._campoDataService.esconderCalendario(this.datepicker, undefined, index);
    }
  }

  mostrarCalendario(index?: number) {
    this._campoDataService.inputDataSelecionado = false;
    this.inputDataSelecionado = false;
    if (index !== null && index !== undefined) {
      this._campoDataService.mostrarCalendario(undefined, this.datepickersArray, index);
      return;
    }
    if (this.datepicker) {
      this._campoDataService.mostrarCalendario(this.datepicker, undefined, index);
    }
  }

  formatarCampoData(valor: any, campoId: string | number) {
    try {
      if (!valor || !valor.target) {
        return '';
      }
      const valorDigitado = valor.target.value;
      const dataParaEnvio = this.converterDataParaEnvio(valorDigitado);

      // Atualiza o FormControl com a data convertida
      if (this.control) {
        this.control.setValue(dataParaEnvio, {emitEvent: false});
      }

      return this._campoDataService.formatarCampoData(dataParaEnvio, campoId);
    } catch (error) {
      console.error('Erro ao formatar data:', error);
      this.errorLogging.logError('Componente de campo-data', error, {
        contexto: 'Falha ao formatar o campo',
        dadosEnviados: error,
      });
    }
  }

  converterDataParaEnvio(dataString: any): string | null {
    // Se não houver valor, for nulo ou apenas espaços em branco
    if (!dataString || (typeof dataString === 'string' && !dataString.trim())) {
      return null;
    }

    // Se já for uma instância de Date (vinda do BsDatepicker, por exemplo)
    if (dataString instanceof Date) {
      if (this.modoMesAno) {
        const mes = String(dataString.getMonth() + 1).padStart(2, '0');
        const ano = dataString.getFullYear();
        return `${mes}/${ano}`;
      }
      return isNaN(dataString.getTime()) ? null : dataString.toISOString();
    }

    const apenasNumeros = String(dataString).replace(/\D/g, '');

    // Retorna null se não houver números após apagar o campo
    if (!apenasNumeros) {
      return null;
    }

    if (this.modoMesAno) {
      if (apenasNumeros.length === 6) {
        const mes = apenasNumeros.slice(0, 2);
        const ano = apenasNumeros.slice(2, 6);
        return `${mes}/${ano}`;
      }
      return dataString;
    }

    if (apenasNumeros.length === 8) {
      const dia = apenasNumeros.slice(0, 2);
      const mes = apenasNumeros.slice(2, 4);
      const ano = apenasNumeros.slice(4, 8);

      return `${ano}-${mes}-${dia}`;
    }

    return dataString;
  }
}
